module.exports = __webpack_public_path__ + "img/brush-bg.21324c83.png";